<nav 
    #topbarContainer 
    id="Topbar" 
    class="pointer-events-none w-full flex justify-between items-start min-h-14 relative md:static"
    role="navigation" 
    aria-label="Main navigation"
>

    @if(hyperlinkMode) {

    <div class="w-[34px] md:w-1/3"></div>

    <div class="md:w-1/3 pointer-events-auto">
        <app-neighbors/>
    </div>

    <div class="w-[34px] md:w-1/3 flex md:justify-end pointer-events-auto">
        <app-fullscreen-toggle/>
    </div>

    } @else {

    <!-- BUTTONS & MENUS -->
    <div class="w-[34px] md:w-1/3 flex items-center gap-x-2 pointer-events-auto">

        <!-- LEFT BUTTONS -->
        <app-navigation/>

        <!-- MENU -->
        @if(!isMobile()){
         
        <app-menu/>
        
        }

    </div>

    <!-- TITLE AND NEIGHBORS -->
    <div class="md:w-1/3 pointer-events-none">
        <app-event-title/>
        <app-neighbors class="pointer-events-auto"/>
    </div>

    <!-- OTROS -->
    <div class="w-[34px] md:w-1/3 flex justify-end gap-x-2 pointer-events-auto">
        
        <!-- <app-button [label]="'Configurations'"/>
        <app-button [label]="'Benefits'"/> -->
        @if(!isMobile()){
            <app-venue-layout/>
        }

        @if(!isMobile()){
            <app-benefits />
        }

        <app-legend/>

        @if(!isMobile()){
            <app-hyperlink/>
        }

        <app-fullscreen-toggle/>

    </div>
    

    <!-- ACTION BUTTONS MOBILE -->
    <div class="md:hidden relative contents left-0 top-full">
       
        <div class="absolute left-0 top-full pointer-events-auto">
            <app-link-action-buttons/>
        </div>

        <div class="absolute right-0 top-full pointer-events-auto">
            <app-hyperlink/>
        </div>
        
    </div>

    }

</nav>
